<template>
  <div>
    <div class="text-h6 font-weight-bold mb-2">Specials</div>

    <v-slide-group show-arrows>
      <v-slide-item v-for="p in specials" :key="p.id">
        <v-card class="mr-3" width="220" rounded="xl" outlined>
          <v-img :src="p.imageUrl || fallbackImg" height="120" contain />
          <v-card-text class="py-2">
            <div class="text-body-2 font-weight-medium line-clamp-2">
              {{ p.name }}
            </div>
            <div class="d-flex align-center justify-space-between mt-1">
              <div class="font-weight-bold">{{ money(p.price) }}</div>
              <v-btn small color="primary" @click="$emit('add', p)">Add</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-slide-item>
    </v-slide-group>

    <div class="d-flex align-center mt-5 mb-2">
      <div class="text-h6 font-weight-bold">Departments</div>
      <v-spacer />
      <v-btn text small @click="$emit('goBrowse')">Browse all</v-btn>
    </div>

    <v-chip-group
      :value="selectedDepartment"
      active-class="primary white--text"
      column
    >
      <v-chip
        v-for="d in departmentNames"
        :key="d"
        class="ma-1"
        outlined
        @click="$emit('update:selectedDepartment', d)"
      >
        {{ d }}
      </v-chip>
    </v-chip-group>

    <div class="text-h6 font-weight-bold mt-5 mb-2">Quick picks</div>

    <v-row dense>
      <v-col v-for="p in quickPicks" :key="p.id" cols="6" sm="4" md="3" lg="2">
        <ProductCard
          :product="p"
          :qty="cartQty(p.id)"
          @add="$emit('add', p)"
          @inc="$emit('inc', p.id)"
          @dec="$emit('dec', p.id)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProductCard from "../components/ProductCard.vue";

export default {
  name: "RemoteStoreHome",
  components: { ProductCard },
  props: {
    products: { type: Array, default: () => [] },
    search: { type: String, default: "" },
    departmentNames: { type: Array, default: () => [] },
    selectedDepartment: { type: String, default: null },
    cart: { type: Object, default: () => ({}) },
  },
  data() {
    return { fallbackImg: "https://via.placeholder.com/300x200?text=No+Image" };
  },
  computed: {
    specials() {
      return (this.products || []).filter((p) => p.special === true).slice(0, 20);
    },
    quickPicks() {
      // v1 simple. later: soldCount desc, featured, etc.
      return (this.products || []).slice(0, 24);
    },
  },
  methods: {
    cartQty(id) {
      return Number(this.cart[String(id)] || 0);
    },
    money(v) {
      const n = Number(v || 0);
      return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
    },
  },
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>